import { DisabledPrompt, Link } from "bcms-react";
import { CustomAccordionClose, CustomAccordionContent, useCustomAccordion } from "components/custom-ui/CustomAccordion";
import { FormContainer, FormRowView } from "components/shared";
import MobileTableAccordionView, { MobileTableAccordionDataItem, MobileTableAccordionToggle } from "components/shared/views/MobileTableAccordionView";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

export default function MobileExternalAccountsTable(props){
  const accounts = props.accounts ?? [];
  const rows = accounts.reduce((acc, account) => {
    acc.push(
      <MobileTableAccordionView key={ account.id }>
        <MobileExternalAccountsToggle account={ account } />
        <MobileExternalAccountsContent account={ account } />
      </MobileTableAccordionView>
    );
    return acc;
  }, []);
  return(
    <div className="transfer-accounts-table">
      { rows }
    </div>
  );
}

function MobileExternalAccountsToggle(props) {
  const { state } = useCustomAccordion();
  const account = props.account ?? {};

  return(
    <MobileTableAccordionToggle icon={ state ? "DownChevronIcon" : "RightChevronIcon" } rightValue="">
      <MobileTableAccordionDataItem columnHeader="" data={ account.nickname } />
      <MobileTableAccordionDataItem columnHeader={ account.institutionName } data="" />
      <MobileTableAccordionDataItem className="status" columnHeader={ account.externalStatus } data="" />
    </MobileTableAccordionToggle>
  );
}

function MobileExternalAccountsContent(props) {
  const account = props.account ?? {};

  return(
      <CustomAccordionContent>
        <div className="custom-accordion-content-container">
          <div className="flex-container custom-accordion-header">
            <p className="flex-width">ACCOUNT DETAILS</p>

            <CustomAccordionClose className="set-width clickable">
              <SVGAsset id="CloseX" className="icon" />
            </CustomAccordionClose>
          </div>

          <FormContainer>
            <FormRowView text="Routing Number" className="light-text">
              <p><b>{ account.routingNumber }</b></p>
            </FormRowView>

            <FormRowView text="Account Type" className="light-text">
              <p><b>{ account.type }</b></p>
            </FormRowView>

            <FormRowView text="Account Number" className="light-text">
              <p><b>{ account.number }</b></p>
            </FormRowView>

            <FormRowView text="Status" className="light-text">
              <p><b>{ account.externalStatus }</b></p>
            </FormRowView>

            <FormRowView text="Date Added" className="light-text">
              <p><b>{ account.dateOpened.format('m/d/Y') }</b></p>
            </FormRowView>

            <FormRowView className="light-text">
              <DisabledPrompt>
                <Link>Edit Account</Link>
              </DisabledPrompt>
            </FormRowView>

            <FormRowView className="light-text">
              <DisabledPrompt>
                <Link>Remove Account</Link>
              </DisabledPrompt>
            </FormRowView>
          </FormContainer>
        </div>
      </CustomAccordionContent>
  );
}